import { Crown, User } from 'lucide-react';
import skillmatchLogo from '../../assets/skillmatch-logo.svg';
import { UserMenu } from './UserMenu';

interface DashboardHeaderProps {
  onOpenProModal: () => void;
  onSignOut: () => void;
  userPlan: {
    plan_type: 'free' | 'pro';
    remaining_conversions: number;
  } | null;
  isLoading: boolean;
  isMobile: boolean;
}

export function DashboardHeader({
  onOpenProModal,
  onSignOut,
  userPlan,
  isLoading,
  isMobile
}: DashboardHeaderProps) {
  const remainingResumes = userPlan?.remaining_conversions ?? 0;

  return (
    <div className="flex flex-col">
      {/* Main Header */}
      <div className="flex items-center justify-between px-4 py-3">
        <div className="flex items-center">
          <img 
            src={skillmatchLogo}
            alt="Skillmatch Logo" 
            className="h-7 sm:h-8"
          />
          <span className="ml-2 inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800">
            BETA
          </span>
        </div>
        
        <div className="flex items-center space-x-2 sm:space-x-4">
          {/* Desktop Pro Button and Stats */}
          <div className="hidden sm:flex items-center space-x-4">
            {userPlan?.plan_type === 'free' && !isLoading && (
              <button
                onClick={onOpenProModal}
                className="inline-flex items-center px-3 py-1.5 border border-transparent text-sm font-medium rounded-md text-white bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                <Crown className="h-4 w-4 mr-1.5" />
                Перейти на Pro
              </button>
            )}
            {userPlan?.plan_type === 'pro' && (
              <span className="px-2 py-1 text-xs font-medium rounded bg-purple-100 text-purple-800">
                PRO
              </span>
            )}
            {!isLoading && (
              <div className="text-sm font-medium">
                <span className="text-gray-500">Осталось резюме: </span>
                <span className={`font-bold ${remainingResumes > 0 ? 'text-green-600' : 'text-red-600'}`}>
                  {remainingResumes}
                </span>
              </div>
            )}
          </div>

          {/* Mobile Pro Button */}
          {userPlan?.plan_type === 'free' && !isLoading && (
            <button
              onClick={onOpenProModal}
              className="sm:hidden inline-flex items-center px-2.5 py-1.5 border border-transparent text-sm font-medium rounded-md text-white bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              <Crown className="h-4 w-4" />
            </button>
          )}

          {/* Mobile Remaining Resumes */}
          {!isLoading && (
            <div className="sm:hidden text-sm font-medium">
              <span className={`font-bold ${remainingResumes > 0 ? 'text-green-600' : 'text-red-600'}`}>
                {remainingResumes}
              </span>
            </div>
          )}

          <UserMenu onSignOut={onSignOut} />
        </div>
      </div>
      
      {/* Referral Banner */}
      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border-y border-blue-100 px-4 py-3">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between max-w-7xl mx-auto space-y-2 sm:space-y-0">
          <div className="flex flex-col sm:flex-row items-start sm:items-center sm:space-x-2">
            <div className="text-sm">
              <span className="font-medium text-blue-800 block sm:inline">Пригласите друзей и получите бонусы!</span>
              <span className="text-blue-600 block sm:inline sm:ml-2">Получите 2 бесплатных конвертации за каждого приглашенного друга.</span>
            </div>
          </div>
          <button
            onClick={onOpenProModal}
            className="text-sm font-medium text-blue-600 hover:text-blue-800 underline whitespace-nowrap"
          >
            Подробнее
          </button>
        </div>
      </div>
    </div>
  );
}